import { Fragment } from "react";
import { Link } from "react-router-dom";
import "./css/gracias.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Gracias from "../../images/gracias/gracias.png";
import Iframe from "react-iframe";
function InfoGracias({ datos }) {
  return (
    <Fragment>
      <Container className="d-flex justify-content-center px-0 px-md-3 py-3 py-md-5">
        <Iframe
          url="https://nomtrack.anvil.app/_/api/cv/"
          position="absolute"
          width="1"
          frameBorder="0"
          height="1"
        />
        <div className="hv-70">
          <div className="gracias-bg p-3 p-md-4">
            <Container className="bg-white">
              <Row>
                <Col md={12} className="p-3 px-md-5">
                  <Image
                    src={Gracias}
                    alt="gracias"
                    className="px-md-5"
                    fluid
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12} className="px-md-5">
                  <h2 className="titulo-gracias">
                    ¡GRACIAS, SU COTIZACIÓN <br /> SE CREÓ CORRECTAMENTE!
                  </h2>
                  <p className="texto-gracias px-md-5 mt-3">
                    Un asesor Hyundai se contactara con usted.
                  </p>
                </Col>
              </Row>
              <Row className="py-3">
                <Col md={12} className="pb-4 d-flex justify-content-center">
                  <Link to="/">
                    <Button
                      variant="primary"
                      type="submit"
                      className="btn-regresar"
                    >
                      Ir al inicio
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </Container>
    </Fragment>
  );
}
export default InfoGracias;